module.exports = __webpack_public_path__ + "img/clickhere.6f021827.gif";